import React from 'react'

const RightArrow = () => {
    return (
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_431_3746)">
                <path d="M21.8936 16.1684L21.8936 17.6392L12.0041 22.9033L12.0041 20.6508L19.2132 16.9265L19.2132 16.8792L12.0032 13.1559L12.0032 10.9033L21.8936 16.1684Z" fill="#454560" />
            </g>
            <defs>
                <clipPath id="clip0_431_3746">
                    <rect width="9.88942" height="12" fill="white" transform="translate(21.8936 22.9033) rotate(-180)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default RightArrow